import React from 'react';
import { Spin, Row, Col, Typography, Button } from 'antd';
import { IContractor } from '../../types/contractor';

const { Text } = Typography;

interface ContractorInfoProps {
  loading: boolean;
  contractor: IContractor;
}

export const ContractorInfo = ({ loading, contractor }: ContractorInfoProps) => {
  if (loading) return <Spin size="small" />;
  if (!contractor) return 'N/A';

  return (
    <Row gutter={[8, 8]}>
      <Col span={24}>
        <Text strong>Name: </Text> {contractor.name}
      </Col>
      {contractor.ceo && (
        <Col span={24}>
          <Text strong>CEO: </Text> {contractor.ceo}
        </Col>
      )}
      {contractor.phone && (
        <Col span={24}>
          <Text strong>Phone: </Text>
          <Button type="link" href={`tel:${contractor.phone}`} style={{ padding: 0 }}>
            {contractor.phone}
          </Button>
        </Col>
      )}
      {contractor.email && (
        <Col span={24}>
          <Text strong>Email: </Text>
          <Button type="link" href={`mailto:${contractor.email}`} style={{ padding: 0 }}>
            {contractor.email}
          </Button>
        </Col>
      )}
      {contractor.webSite && (
        <Col span={24}>
          <Text strong>Website: </Text>
          <Button
            type="link"
            onClick={() => window.open(contractor.webSite, '_blank')}
            style={{ padding: 0 }}>
            {contractor.webSite}
          </Button>
        </Col>
      )}
    </Row>
  );
};
